<script setup lang="ts">
    import { computed, ref, watch } from 'vue';
    import { useSearchContext } from '../composables/searchContext';
    import type { ResultType, SortOrder } from '../models/SearchModels';
    import AppliedFilters from './AppliedFilters.vue';

    const search = useSearchContext();
    const query = ref(search.state.query);
    const sortOptions: Array<[SortOrder, string]> = [['r', 'Recommended'], ['a', 'Title (A to Z)'], ['d', 'Title (Z to A)'], ['l', 'Latest']];
    const selectedItem = computed(() => sortOptions.find(([value]) => value === search.state.sortOrder)?.[1] ?? 'Recommended');
    watch(() => search.state.query, (value) => { query.value = value; });
    function submit(): void { search.setQuery(query.value); }
    function setResultType(event: Event): void { search.setResultType((event.target as HTMLInputElement).value as ResultType); }
</script>

<template>
    <div class="search-controls">
        <div id="divMobileControls" class="mobileOnly">
            <div class="row">
                <div class="col-6">
                    <button id="mbtnFilter" type="button" class="btn btn-outline-secondary" :aria-expanded="search.mobileFiltersVisible.value" @click="search.mobileFiltersVisible.value = !search.mobileFiltersVisible.value">
                        <img :src="'/Portals/0/images/filter-icon.png'" alt="" /><span class="btn-text">Filter</span>
                    </button>
                </div>
                <div class="col-6">
                    <button id="mbtnSortBy" type="button" class="btn btn-outline-secondary" :aria-expanded="search.mobileSortVisible.value" @click="search.mobileSortVisible.value = !search.mobileSortVisible.value">
                        <img :src="'/Portals/0/images/sortby-icon.png'" alt="" /><span class="btn-text">Sort By</span>
                    </button>
                </div>
            </div>

            <div class="sortOptions">
                <span>Sort by: </span><span>{{selectedItem}}</span>
            </div>

            <AppliedFilters mobile />
        </div>

        <div v-if="!search.isLoading.value && (search.state.division !== 'all' || search.totalResults.value === 0)" id="divSort" class="sort-by" :class="{ 'mobile-panel-open': search.mobileSortVisible.value }">
            <h4>Sort by</h4>
            <div id="sortContainer">
                <label v-for="([value, label]) in sortOptions" :key="value" class="radio" :class="{ checked: value === search.state.sortOrder }">
                    <input type="radio" name="sortOptions" :value="value" :checked="value === search.state.sortOrder" @change="search.setSortOrder(value)" /> {{ label }}
                </label>
            </div>
        </div>
    </div>
</template>
